import { useContext } from 'react';
import useAxios from '../hooks/useAxios';
import {COUGH_RECORDING_URL} from './constants';
import AuthContext from '../context/AuthContext';

/**
 * Hook for interacting with the Cough API.
 *
 * @returns {Object} An object containing functions to interact with the API.
 */
export const useCoughApi = () => {
  const {authTokens, setAuthTokens} = useContext(AuthContext);
  const api = useAxios();

  /**
   * Posts a cough recording to the server.
   *
   * @param {FormData} formData - The FormData object containing the cough recording data.
   * @returns {Promise} A Promise that resolves when the request is complete.
   */
  const postCoughRecording = formData =>
    api.post(COUGH_RECORDING_URL, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${authTokens?.access_token}`
      },
    });

  return {
    postCoughRecording,
  };
};
